import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ArrayInput,
  SimpleFormIterator,
  AutocompleteInput,
  ImageInput,
  ImageField,
  LongTextInput,
  FileField,
  FileInput,
  NumberInput
} from "react-admin";
import { month, year } from "../../constant/Date";
import React from "react";
import { typeMessage } from "../../constant/TypeMessage";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
import { DateInput } from 'react-admin-date-inputs';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import 'moment/locale/th';

class BillForm extends React.Component {
  state = {
    project: null,
  };

  componentDidMount() {
    const { record: { project } } = this.props
    if (project)
      this.setState({ project })
  }

  render() {
    // const redirect = (basePath, id, data) => `/bill`;
    const { project } = this.state;
    const props = this.props;
    const { record: { _id } } = props
    const role = localStorage.getItem("role");
    const myProject = JSON.parse(localStorage.getItem("project"));
    const filter = role ? (role === SUPERADMIN ? {} : { _id: myProject }) : {};

    return (
      <SimpleForm {...props}>
        <ReferenceInput
          validate={[required()]}
          disabled={project ? true : false}
          onChange={(event, key, payload) => this.setState({ project: key })}
          source="project"
          reference="project"
          filter={filter}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <DateInput
          source="date" label="บิลประจำเดือน/ปี" options={{ format: 'MMM/YYYY' }} providerOptions={{ utils: MomentUtils }}
          validate={[required()]} />
        {project && (
          <ReferenceInput
            allowEmpty
            filter={{ project }}
            source="room"
            reference="room"
            validate={[required()]}
            disabled={_id}
          >
            {
              _id ?
                <SelectInput optionText="name" /> : <AutocompleteInput optionText="name" />
            }
          </ReferenceInput>
        )}
        {project &&
          <ArrayInput source="bill" label="บิล">
            <SimpleFormIterator>
              <ReferenceInput
                filter={{ project }}
                source="type"
                reference="billtype"
                validate={[required()]}
                label="ประเภทบิล"
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
              <NumberInput source="price" step={1} validate={[required()]} label="จำนวนที่ต้องจ่าย" />
            </SimpleFormIterator>
          </ArrayInput>
        }
        {/* {project && <NumberInput source="water_bill" step={1} />}
        {project && (
          <ImageInput
            multiple={false}
            source="water_bill_image"
            accept="image/*"
          >
            <ImageField source="url" title="title" />
          </ImageInput>
        )}
        {project && <NumberInput source="electric_bill" step={1} />}
        {project && (
          <ImageInput
            multiple={false}
            source="electric_bill_image"
            accept="image/*"
          >
            <ImageField source="url" title="title" />
          </ImageInput>
        )}
        {project && <NumberInput source="maintenance_fee" step={1} />}
        {project && <NumberInput source="installment" step={1} />} */}
      </SimpleForm>
    );
  }
}

const CustomSelectInput = ({ onChangeCustomHandler, ...rest }) => (
  <SelectInput
    onChange={(event, key, payload) => {
      onChangeCustomHandler(key);
    }}
    {...rest}
  />
);

export default BillForm;



// WEBPACK FOOTER //
// ./src/components/bill/BillForm.js